var _rect, _rect2, _rect3, _rect4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 36,
    viewBox: "0 0 20 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 34,
    rx: 2,
    stroke: "#F26D6B",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 6.25,
    width: 15.5,
    height: 0.5,
    fill: "#F26D6B",
    stroke: "#F26D6B",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 29.25,
    width: 15.5,
    height: 0.5,
    fill: "#F26D6B",
    stroke: "#F26D6B",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 3.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#F26D6B",
    stroke: "#F26D6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 32,
    r: 0.5,
    fill: "#F26D6B",
    stroke: "#F26D6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneActive);
export default __webpack_public_path__ + "static/media/phoneActive.da239ecc0ad51fd37df4fd9297a18fa2.svg";
export { ForwardRef as ReactComponent };